/** @type {AliasListProps} */
export const aliasesList = new Map([
  /**
   * Aliases
   */
  [
    "push-up",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(-«V»<«O»>)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "push-down",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(«V»<«O»>)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "push-left",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(-«V»<«O»>)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "push-right",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(«V»<«O»>)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "pull-up",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(0rem<«O»>)"]],
        ["I", ["ty(«V»)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "pull-down",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(0rem<«O»>)"]],
        ["I", ["ty(-«V»)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "pull-left",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(0rem<«O»>)"]],
        ["I", ["tx(«V»)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "pull-right",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(0rem<«O»>)"]],
        ["I", ["tx(-«V»)"]],
        ["V", "0.5rem"],
      ])
    ),
  ],
  [
    "grow",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["s(1<«O»>)"]],
        ["I", ["s(«V»)"]],
        ["V", "0"],
      ])
    ),
  ],
  [
    "shrink",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["s(0<«O»>)"]],
        ["I", ["s(«V»)"]],
        ["V", "2"],
      ])
    ),
  ],
  [
    "fade-in",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["o(«V»<«O»>)"]],
        ["I", ["o(0)"]],
        ["V", "1"],
      ])
    ),
  ],
  [
    "fade-out",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["o(«V»<«O»>)"]],
        ["V", "0"],
      ])
    ),
  ],
  [
    "shadow-xs",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 1px 2px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.15)"],
      ])
    ),
  ],
  [
    "shadow-sm",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 2px 4px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.15)"],
      ])
    ),
  ],
  [
    "shadow",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 4px 6px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.2)"],
      ])
    ),
  ],
  [
    "shadow-md",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 4px 6px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.2)"],
      ])
    ),
  ],
  [
    "shadow-lg",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 8px 16px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.25)"],
      ])
    ),
  ],
  [
    "shadow-xl",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bs(0px 16px 48px 0px «V»<«O»>)"]],
        ["V", "rgba(0,0,0,0.3)"],
      ])
    ),
  ],
  [
    "reveal-path",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["stroke-dasharray($length $length<«O»>)"]],
        ["I", ["$length(get(length))", "stroke-dasharray(0px $length)"]],
      ])
    ),
  ],
  [
    "translate-along-path",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "tx($length<is-offset-path:true,oriented:false,«O»>)",
            "ty($length<is-offset-path:true,oriented:false,«O»>)",
            "r(0deg<is-offset-path:true,oriented:false,«O»>)",
          ],
        ],
        ["I", ["$length(get(length<«O»>))"]],
      ])
    ),
  ],
  [
    "clip-right",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% 0%,calc(100% + «V») 0%,100% 100%,0% 100%)<«O»>)",
          ],
        ],
        ["I", ["clip-path(polygon(0% 0%,0% 0%,calc(0% - «V») 100%,0% 100%))"]],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "clip-left",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(calc(0% - «V») 0%,100% 0%,100% 100%,0% 100%)<«O»>)",
          ],
        ],
        [
          "I",
          [
            "clip-path(polygon(100% 0%,100% 0%,calc(100% + «V») 100%,calc(100% + «V») 100%))",
          ],
        ],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "clip-up",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% calc(0% - «V»),100% 0%,100% 100%,0% 100%)<«O»>)",
          ],
        ],
        [
          "I",
          [
            "clip-path(polygon(0% 100%,100% calc(100% + «V»),100% 100%,0% 100%))",
          ],
        ],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "clip-down",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% calc(100% + «V»),99% 98%,100% 0%,0% 0%)<«O»>)",
          ],
        ],
        ["I", ["clip-path(polygon(0% 0%,100% calc(0% - «V»),100% 0%,0% 0%))"]],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "reveal-up",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% 100%,100% 100%,100% 0%,0% 0%)<«O»>)",
            "ty(0%<«O»>)",
          ],
        ],
        ["I", ["clip-path(polygon(0% 0%,100% 0%,100% 0%,0% 0%))", "ty(100%)"]],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "reveal-down",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% 100%,100% 100%,100% 0%,0% 0%)<«O»>)",
            "ty(0%<«O»>)",
          ],
        ],
        [
          "I",
          [
            "clip-path(polygon(0% 100%,100% 100%,100% 100%,0% 100%))",
            "ty(-100%)",
          ],
        ],
        ["V", "100%"],
      ])
    ),
  ],
  [
    "reveal-left",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% 0%,100% 0%,100% 100%,0% 100%)<«O»>)",
            "tx(0%<«O»>)",
          ],
        ],
        [
          "I",
          ["clip-path(polygon(0% 0%,0% 0%,0% 100%,0% 100%)<«O»>)", "tx(100%)"],
        ],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "reveal-right",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "clip-path(polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)<«O»>)",
            "tx(0%<«O»>)",
          ],
        ],
        [
          "I",
          [
            "clip-path(polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)<«O»>)",
            "tx(-100%)",
          ],
        ],
        ["V", "0%"],
      ])
    ),
  ],
  [
    "bg-lighten",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bg(rgba((+)«V»,(+)«V»,(+)«V»,?)<«O»>)"]],
      ])
    ),
  ],
  [
    "bg-darken",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["bg(rgba((-)«V»,(-)«V»,(-)«V»,?)<«O»>)"]],
      ])
    ),
  ],
  [
    "bg-opacity",
    new Map(/** @type {AliasProps} */ ([["R", ["bg(rgba(?,?,?,«V»)<«O»>)"]]])),
  ],
  [
    "text-lighten",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["color(rgba((+)«V»,(+)«V»,(+)«V»,?)<«O»>)"]],
      ])
    ),
  ],
  [
    "text-darken",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["color(rgba((-)«V»,(-)«V»,(-)«V»,?)<«O»>)"]],
      ])
    ),
  ],
  [
    "text-opacity",
    new Map(
      /** @type {AliasProps} */ ([["R", ["color(rgba(?,?,?,«V»)<«O»>)"]]])
    ),
  ],
  [
    "parallax-y",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(«V»<«O»>)"]],
        // ["I", ["ty(«V»)"]],
        ["T", "method:parallax"],
        ["V", "2rem"],
      ])
    ),
  ],
  [
    "parallax-x",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(«V»<«O»>)"]],
        // ["I", ["tx(-«V»)"]],
        ["T", "method:parallax"],
        ["V", "2rem"],
      ])
    ),
  ],

  /**
   * Loops
   */
  [
    "jump",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "[0%:[ty(0rem)<easing:bezier(0.3,0,0.7,0)>],50%:[ty(-«V»)],100%:[ty(0rem)<spring>]<infinite,«O»>]",
          ],
        ],
        ["V", "1rem"],
        ["O", "2s"],
      ])
    ),
  ],
  [
    "spin",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["r(«V»<linear,infinite,«O»>)"]],
        ["V", "360deg"],
        ["O", "2s"],
      ])
    ),
  ],
  [
    "blink",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["o(«V»<alternate,infinite,«O»>)"]],
        ["V", "0"],
        ["O", "0.5s"],
      ])
    ),
  ],
  [
    "fly",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(«V»<alternate,infinite,«O»>)"]],
        ["I", ["ty(-«V»)"]],
        ["V", "1rem"],
        ["O", "1s"],
      ])
    ),
  ],
  [
    "pulse",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["s(calc(1.001 + «V»)<alternate,infinite,«O»>)"]],
        ["I", ["s(calc(1.001 - «V»))"]],
        ["V", "0.2"],
        ["O", "1s"],
      ])
    ),
  ],
  [
    "swing",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["r(«V»<alternate,infinite,«O»>)"]],
        ["I", ["r(-«V»)"]],
        ["V", "25deg"],
        ["O", "1s"],
      ])
    ),
  ],
  [
    "wobble-h",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(«V»<alternate,infinite,«O»>)"]],
        ["I", ["tx(-«V»)"]],
        ["V", "1rem"],
        ["O", "1s"],
      ])
    ),
  ],
  [
    "wobble-v",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(«V»<alternate,infinite,«O»>)"]],
        ["I", ["ty(-«V»)"]],
        ["V", "1rem"],
        ["O", "1s"],
      ])
    ),
  ],
  [
    "radiate",
    new Map(
      /** @type {AliasProps} */ ([
        ["I", ["bs(0px 0px 0px 0px «V»)"]],
        ["R", ["bs(0px 0px 0px «CV» rgba(?,?,?,0)<1s,infinite,«O»>)"]],
        ["V", "rgba(0,0,0,1)"],
        ["O", "1s"],
        [
          "CV",
          new Map([
            ["name", "spread"],
            ["value", "1rem"],
          ]),
        ],
      ])
    ),
  ],
  [
    "tada",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "[20%:[s(calc(1 - «V»))],30%:[s(calc(1 + «V»)) r(calc(100deg * «V»))],40%:[r(calc(-100deg * «V»))],50%:[r(calc(100deg * «V»))],60%:[r(0deg)],100%:[s(calc(1)) <spring>],<infinite,«O»>]",
          ],
        ],
        ["V", "0.1"],
        ["O", "2s"],
      ])
    ),
  ],
  [
    "slide-h",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["tx(100%<infinite,«O»>)"]],
        ["I", ["tx(-100%)"]],
        ["O", "2s"],
      ])
    ),
  ],
  [
    "slide-v",
    new Map(
      /** @type {AliasProps} */ ([
        ["R", ["ty(100%<infinite,«O»>)"]],
        ["I", ["ty(-100%)"]],
        ["O", "2s"],
      ])
    ),
  ],
  [
    "orbit",
    new Map(
      /** @type {AliasProps} */ ([
        [
          "R",
          [
            "r(360deg<linear,infinite,order:1,«O»>)",
            "tx(«V»<0s,linear,order:2>)",
            "rz((-)360deg<linear,infinite,order:3,«O»>)",
          ],
        ],
        ["I", ["transform-origin(50%)", "r(0deg)", "tx(«V»)"]],
        ["V", "1rem"],
        ["O", "2s"],
      ])
    ),
  ],
]);

export const aliasesListArray = Array.from(aliasesList.keys());
